export const ONBOARDING_COPY = {
  eyebrow: "Quick tour",
  title: "Meet Marcus.",
  description:
    "He'll show you around the platform and explain how our agents can help increase your ecommerce sales.",
  primaryAction: "Start tour",
  secondaryAction: "Skip",
} as const;

export const ONBOARDING_EXPLORE_NEXT_STEP_COPY =
  "Whenever you're ready, click 'Next step' and we'll dive into Static Ads.";
export const ONBOARDING_NEXT_STEP_COPY = "Now that we've seen static formats, let's click 'Next step' to explore Video Ads.";
export const ONBOARDING_COMPACT_GUIDE_PREFACE =
  "Let's go through the features and how agents can boost your performance.";

export const ONBOARDING_SPOKEN_INTRO = `Marcus turns ideas into performance: create conversion-focused static ads, clone proven video ads, and scale paid campaigns with agent expertise. ${ONBOARDING_EXPLORE_NEXT_STEP_COPY}`;
